"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = void 0;
var vue_1 = require("vue");
var _withScopeId = function (n) { return (vue_1.pushScopeId("data-v-26c27823"), n = n(), vue_1.popScopeId(), n); };
var _hoisted_1 = { class: "member" };
var _hoisted_2 = { class: "list" };
var _hoisted_3 = ["onClick"];
var _hoisted_4 = ["src"];
var _hoisted_5 = { class: "name" };
var _hoisted_6 = ["onClick"];
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (vue_1.openBlock(), vue_1.createElementBlock("main", _hoisted_1, [
        vue_1.createElementVNode("ul", _hoisted_2, [
            (vue_1.openBlock(true), vue_1.createElementBlock(vue_1.Fragment, null, vue_1.renderList(_ctx.list, function (item, index) {
                return (vue_1.openBlock(), vue_1.createElementBlock("li", {
                    class: "list-item",
                    key: index
                }, [
                    vue_1.createElementVNode("aside", {
                        onClick: function ($event) { return (_ctx.handleMemberProfileShow(item)); }
                    }, [
                        vue_1.createElementVNode("img", {
                            class: "avatar",
                            src: (item === null || item === void 0 ? void 0 : item.avatar) || 'https://image.iguopin.com/data/app/im-logo.png',
                            onerror: "this.src='https://image.iguopin.com/data/app/im-logo.png'"
                        }, null, 8, _hoisted_4),
                        vue_1.createElementVNode("span", _hoisted_5, vue_1.toDisplayString((item === null || item === void 0 ? void 0 : item.nick) || (item === null || item === void 0 ? void 0 : item.userID)), 1),
                        vue_1.createElementVNode("span", null, vue_1.toDisplayString(_ctx.handleRoleName(item)), 1)
                    ], 8, _hoisted_3),
                    (item.role !== 'Owner' && _ctx.isShowDel)
                        ? (vue_1.openBlock(), vue_1.createElementBlock("i", {
                            key: 0,
                            class: "icon icon-del",
                            onClick: function ($event) { return (_ctx.submit(item)); }
                        }, null, 8, _hoisted_6))
                        : vue_1.createCommentVNode("", true)
                ]));
            }), 128)),
            (_ctx.list.length < _ctx.total)
                ? (vue_1.openBlock(), vue_1.createElementBlock("li", {
                    key: 0,
                    class: "list-item",
                    onClick: _cache[0] || (_cache[0] =
                        //@ts-ignore
                        function () {
                            var args = [];
                            for (var _i = 0; _i < arguments.length; _i++) {
                                args[_i] = arguments[_i];
                            }
                            return (_ctx.getMore && _ctx.getMore.apply(_ctx, args));
                        })
                }, vue_1.toDisplayString(_ctx.$t("TUIChat.manage.\u67E5\u770B\u66F4\u591A")), 1))
                : vue_1.createCommentVNode("", true)
        ])
    ]));
}
exports.render = render;
